import { SettingMetas } from "@/api/settingMetas";
import { Customer } from "@/api/customer";
import { languages } from "@/plugins/languages";
const query = JSON.parse(localStorage.getItem("asus_chat_query")) || {};
const state = {
  dir: "ltr",
  internet_status: "online", //online/offline
  idleTime: 0,
  totalTime: 0,
  offlineTime: 0,
  storeMode: false,
  customerSurvey: {
    country: query.country || "", // 實際連接的 country, form select skill
    detectedCountry: localStorage.getItem("asus_chat_detectedCountry") || "",
    isAgreeWithGDPR: true, // default
    isAgreeWithCallBack: false, // default
    asusWebSiteCountry: query.asusWebSiteCountry || "", // from ?country=
    platform: query.platform || "",
    device: query.device || "",
    chatBotRoomId: query.chatBotRoomId || "",
    cusid: query.cusid || "",
    productSN: query.productSN || "",
    product: query.product || "",
  },
  settingMetas_beforeChat: {
    ageDesc: "",
    agentBusy: "",
    bbyDeclaration: "",
    isAge: false,
    isAsusMemberLogin_EC: false,
    nonServiceTime: "",
    privacyNotice: "",
    satisfactionConsent: "",
    unServiceTime: "",
    isInWarrantyCheck: false,
  },
  settingMetas_chatting: {
    adGoToContact: "",
    adGoToSatisfactionConsent: "",
    agentDisconnect: "",
    agentIntro: "",
    idleDisconnect: "",
    idleDisconnectTime: "",
    idleNotice: "",
    idleNoticeTime: "",
    terminationService: "",
    transferAgentIntro: "",
    isCustomerDownloadChat: "",
    officialSiteUrl: "",
    accountUrl: "",
  },
  bulletins: [],
  productListByCountry: null,
  uploadImageProcess: 0,
  uploadFileProcess: 0,
  heartBeat: {
    counts: 0,
    lastestTime: "",
  },
};

const actions = {
  getAsusMemberInfo({ state, dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      Customer.GetAsusMemberInfo(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAllCountryConfigs({ dispatch, commit }, payload) {
    // console.log('getAllCountryConfigs');
    // payload = country
    return new Promise((resolve, reject) => {
      SettingMetas.GetBeforeChat(payload)
        .then(async (res) => {
          commit("setCustomerSurvey", {
            asusWebSiteCountry: payload,
          });
          await dispatch("getChatting", payload);
          await dispatch("initProductListByCountry");
          await dispatch("getBulletinList");

          commit("setBeforeChatData", res.data);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getBulletinList({ state, commit }, _) {
    let params = {
      country: state.customerSurvey.asusWebSiteCountry,
      pageRequestParameter: {
        isReturnAllDataAndNoPage: true,
        targetPage: 0,
        showCount: 0,
      },
    };
    return new Promise((resolve, reject) => {
      Customer.GetBulletinList(params)
        .then((res) => {
          commit("setBulletin", res.data.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  initProductListByCountry({ state, commit }, _) {
    // console.log('initProductListByCountry');
    return new Promise((resolve, reject) => {
      Customer.GetCountryAllSkill({
        countryId: state.customerSurvey.asusWebSiteCountry,
      })
        .then((res) => {
          // console.log(res);
          resolve(res);
          commit("setProductList", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getChatting({ commit }, country) {
    return new Promise((resolve, reject) => {
      SettingMetas.GetChatting(country)
        .then((res) => {
          // console.log(res);
          commit("setChatingData", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  heartBeat({ commit }, payload) {
    let lastestTime = new Date().toLocaleTimeString();
    commit("setHeartBeat", lastestTime);
  },
  stopHeartBeat({ commit }) {
    commit("setHeartBeat", "");
  },
};

const mutations = {
  setInternetStatus(state, payload) {
    state.internet_status = payload;
  },
  toogleWiget(state, payload) {
    state.showWidget = payload ? true : false;
    state.showWidgetBtn = payload ? false : true;
  },
  setStoreMode(state, payload) {
    state.storeMode = payload;
  },
  setCustomerSurvey(state, payload) {
    state.customerSurvey = Object.assign(state.customerSurvey, payload);
    localStorage.setItem(
      "asus_chat_query",
      JSON.stringify(state.customerSurvey)
    );
  },
  setBeforeChatData(state, payload) {
    state.settingMetas_beforeChat = payload;
  },
  setChatingData(state, payload) {
    state.settingMetas_chatting = payload;
  },
  setProductList(state, payload) {
    if (payload.length) {
      state.productListByCountry = payload.map((el) => {
        return {
          text: el.skillName_Local,
          country: el.countryId,
          product: el.skillName_Global,
          isSkillService: el.isSkillService,
        };
      });
    } else {
      state.productListByCountry = null;
    }
  },
  setBulletin(state, payload) {
    state.bulletins = payload;
  },
  // idle
  setIdleTime(state, payload) {
    if (payload == "on") {
      state.idleTime++;
    } else {
      state.idleTime = 0;
    }
  },
  setTotalTime(state, payload) {
    if (payload == "on") {
      state.totalTime++;
    } else {
      state.totalTime = 0;
    }
  },
  setOfflineTime(state, payload) {
    if (payload == "on") {
      state.offlineTime++;
    } else {
      state.offlineTime = 0;
    }
  },
  setDevice(state, payload) {
    state.customerSurvey.device = payload;
  },
  setDir(state, payload) {
    state.dir = payload;
  },
  setUploadImageProcess(state, payload) {
    state.uploadImageProcess = payload;
  },
  setUploadFileProcess(state, payload) {
    state.uploadFileProcess = payload;
  },
  setHeartBeat(state, payload) {
    if (payload) {
      state.heartBeat.counts++;
      state.heartBeat.lastestTime = payload;
    } else {
      state.heartBeat.counts = 0;
      state.heartBeat.lastestTime = "";
    }
  },
};
const getters = {
  lang(state) {
    const country = state.customerSurvey.asusWebSiteCountry.toUpperCase();

    function getLan() {
      return languages.includes(country) ? country : "EN";
    }

    if (country) {
      if (country == "TW-EC") {
        return "TW";
      } else {
        return getLan();
      }
    } else {
      return "EN";
    }
  },
  customerSurvey: (state) => {
    return {
      asusWebSiteCountry: state.customerSurvey.asusWebSiteCountry,
      platform: state.customerSurvey.platform,
      device: state.customerSurvey.device,
    };
  },
  set_Chat: (state) => {
    return {
      idleNotice: state.settingMetas_chatting.idleNotice,
      idleNoticeTime: state.settingMetas_chatting.idleNoticeTime || 120, // default 2 min
      idleDisconnectTime: state.settingMetas_chatting.idleDisconnectTime || 120, // default 2 min ,
      isCustomerDownloadChat:
        state.settingMetas_chatting.isCustomerDownloadChat,
    };
  },
  set_beforeChat: (state) => {
    return {
      isBBY: state.settingMetas_beforeChat.isBBY,
      isAge: state.settingMetas_beforeChat.isAge,
      ecAge: state.settingMetas_beforeChat.ecAge,
      isAsusMemberLogin: state.settingMetas_beforeChat.isAsusMemberLogin,
      isAsusMemberLogin_EC: state.settingMetas_beforeChat.isAsusMemberLogin_EC,
      accountUrl: state.settingMetas_beforeChat.accountUrl,
      officialSiteUrl: state.settingMetas_beforeChat.officialSiteUrl,
    };
  },
  storeMode: (state) => state.storeMode,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
